import React, { ComponentProps } from 'react';
import { asFetchableView, useViewContext } from '../../../_lib/ViewFetcher';
import {
  Form, HiddenParam, Input, RequiredHelpPhrase, Row, SonForm, SubmitButton, Textarea, TextAreaParam, TextParam, useForm,
} from '../../../_lib/Form2';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { HiddenInput } from '../../../_lib/Form2/elements/HiddenInput/HiddenInput';
import { translatePageType } from '../../../_lib/components/PageType/PageTypeTitle';
import { PageType } from '../../../types/api/PageType';
import { useDelayed } from '../../../hooks/useDelayed';

export type PageMembershipMatchingRulePageLeadEdit = {
  form: SonForm<TextParam<'title'>
  | TextAreaParam<'description'>
  | HiddenParam<'areaPageType'>
  | HiddenParam<'roleName'>>,
};

function PageMembershipMatchingRulePageLeadEdit({ form }: PageMembershipMatchingRulePageLeadEdit) {
  const { t } = useSonTranslation('PageMembershipMatchingRulePageLead');
  const { switchToDefaultView } = useViewContext();
  const { refresh } = useRefreshBlock();
  const delayedRefresh = useDelayed(() => {
    switchToDefaultView();
    refresh();
  });

  const { formProps, params, fetchState } = useForm({ form, onSuccess: delayedRefresh });
  const titleParams = params.getByName('title');
  const descriptionParams = params.getByName('description');
  const areaPageTypeParams = params.getByName('areaPageType');
  const roleNameParams = params.getByName('roleName');

  return (
    <Form {...formProps}>
      <RequiredHelpPhrase />
      <HiddenInput {...areaPageTypeParams} />
      <HiddenInput {...roleNameParams} />
      <Row>
        <Input
          label={t('titleLabel')}
          param={titleParams}
          defaultValue={t(
            'titleDefaultValue',
            { areaPageType: translatePageType(areaPageTypeParams.value as PageType), roleName: roleNameParams.value },
          )}
        />
      </Row>
      <Row>
        <Textarea label={t('descriptionLabel')} param={descriptionParams} />
      </Row>
      <SubmitButton
        buttonLabel={t('PageLead:actions.edit.button')}
        messageSuccess={t('PageLead:actions.edit.status.success')}
        messageSending={t('PageLead:actions.edit.status.sending')}
        messageFail={t('PageLead:actions.edit.status.fail')}
        fetchState={fetchState}
      />
    </Form>
  );
}

export const PageMembershipMatchingRulePageLeadEditView =
  asFetchableView(PageMembershipMatchingRulePageLeadEdit);
export type PageMembershipMatchingRulePageLeadEditView =
  ComponentProps<typeof PageMembershipMatchingRulePageLeadEditView>;
